// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import { errorAction } from '~/redux/commonActions'
import { ACTION_WEBSKED_NEW_TASK, getWebskedTasks } from '../websked'

export default (action$, store, { serviceResolver }) =>
  action$.ofType(ACTION_WEBSKED_NEW_TASK).mergeMap((action) => {
    const thirdPartyIntegrationService = serviceResolver(
      'thirdPartyIntegrationService'
    )
    return Observable.from(
      thirdPartyIntegrationService(
        `/websked/#/task-form?storyID=${action.payload}`,
        ['esc'],
        [600, 580]
      )
    )
      .map((_) => {
        return getWebskedTasks()
      })
      .catch((error) => Observable.of(errorAction(error)))
  })
